import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class Test140626 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 14/06/2026 (Marine Martial Arts Lumpini) Candidates</h3>
      <br />
      <br />


      <div><Link to='/conduct-wichaic'>1. AAT  5642  MR.WICHAI	CHEEVAPITAKPHOL(2DAN)---Trying for 3DAN</Link></div>
      <br />
        <div><Link to='/conduct-wannatouchp'>2. AAT  7847  MR.WANNATOUCH PRASERT(3KYU)---Trying for 2KYU</Link></div>
        <br />
        <div><Link to='/conduct-jacquesp'>3. AAT  7369  MR.JACQUES DU PLESSIS(3KYU)---Trying for 2KYU</Link></div>
        <br />
        <div><Link to='/conduct-anantayak'>4. AAT  7749  MS.ANANTAYA	KULTANAKORN(5KYU)---Trying for 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-karnts'>5. AAT  8007  MR.KARNT SRISUWAN(7KYU)---Trying for 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-pakawadn'>6. AAT  8008  MR.PAKAWAD NANTAJURAPLO(7KYU)---Trying for 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-patawank'>7. AAT  8050  MS.PATAWAN KANPLIEN(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-kosinm'>8. AAT  8051  MR.KOSIN	MUNGCHAROEN(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-vunqt'>9. AAT  8021  MS.NGUYEN QUYNH TRAM VU(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-praphatpongy'>17. AAT  8038  MR.PRAPHATPONG  YOODEE(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-naras'>10. AAT  8040  MR.NARA  SINGHSATHITSUK(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-marks'>11. AAT 8041  MR.MARK SRIAPORN(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-marvins'>12. AAT 8042  MR.MARVIN SRIAPORN(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-mitts'>13. AAT 8043  MR.MITT SRIAPORN(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-pats'>14. AAT  8016  MR.PAT SUTHAPUNNAKUL(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-jasona'>15. AAT 8053  MR.HUA YIK ANG(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-nithiss'>16. AAT  8055  MR.NITHIS SIWATHEWINTRA(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-phusins'>17. AAT  8056  MR.PHUSIN	SIWATHEWINTRA(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-vaayuk'>18. AAT  8057  MR.VAAYU KHATTRI(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-niksak'>19. AAT  8058  MR.NIKSA	KIATTHANAPIBOON(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-phattarakritl'>20. AAT  8059  MR.PHATTARAKRIT LAPANALARPLOY(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-piyabutrl'>21. AAT  8060  MR.PIYABUTR LORGRAILERS(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-paricharts'>22. AAT  8061  MS.PARICHART SRIAPORN(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-paricharts'>23. AAT  8062  MR.PHUPHUM JIRACHANKIAT(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />








        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Test140626;
